import { lazy } from 'react';
import PATH from 'routes/paths';

const HQApprovalQueueList = lazy(() =>
  import(
    'components/layout/mainPages/adminPages/internalRequest/HQApprovalQueueList'
  )
);

// Admin-specific internal request detail view
const AdminInternalRequest = lazy(() =>
  import(
    'components/layout/mainPages/adminPages/internalRequest/AdminInternalRequest'
  )
);

// Import the same component used by PM routes for viewing internal requests
const InternalRequest = lazy(() =>
  import('components/layout/mainPages/pmPages/internalRequest/InternalRequest')
);

const InternalRequestList = lazy(() =>
  import(
    'components/layout/mainPages/pmPages/internalRequest/InternalRequestList'
  )
);

// IMPORTANT: More specific routes MUST come first!

// Admin internal request detail view at /internal-requests/:id
const ADMIN_INTERNAL_REQUEST = {
  component: AdminInternalRequest,
  path: PATH.INTERNAL_REQUEST.ONE,
  exact: true,
  isProtected: true,
};

// Allow admin users to access project-scoped internal request detail pages
const INTERNAL_REQUEST = {
  component: InternalRequest,
  path: PATH.PROJECT.INTERNAL_REQUEST.ONE,
  exact: true,
  isProtected: true,
};

const INTERNAL_REQUEST_LIST = {
  component: InternalRequestList,
  path: PATH.PROJECT.INTERNAL_REQUEST.LIST,
  exact: false,
  isProtected: true,
};

// Admin internal requests list at /internal-requests/
const ADMIN_INTERNAL_REQUEST_LIST = {
  component: HQApprovalQueueList,
  path: PATH.INTERNAL_REQUEST.LIST,
  exact: true,
  isProtected: true,
};

export default [
  ADMIN_INTERNAL_REQUEST,
  INTERNAL_REQUEST,
  INTERNAL_REQUEST_LIST,
  ADMIN_INTERNAL_REQUEST_LIST,
];
